import {
  darkThemeStyles,
  JupiterTheme,
  MockHook,
} from '@jupiterone/jupiter-web-toolkit';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import useUserDefaultAppSelectorLogic, {
  UserDefaultAppSelectorComponentProps,
} from './useUserDefaultAppSelectorLogic';

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    ...darkThemeStyles,
    formControl: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    white: { color: theme.palette.common.white },
  });
});

export const UserDefaultAppSelectorComponent = ({
  apps,
  defaultApp,
  handleDefaultAppChange,
}: UserDefaultAppSelectorComponentProps) => {
  const classes = useStyles();

  const InputLabelProps = {
    className: classes.textInputLabel,
    classes: {
      disabled: classes.textInputLabelDisabled,
      focused: classes.textInputLabelFocused,
    },
  };
  const InputProps = {
    className: classes.textInput,
    classes: {
      disabled: classes.disabled,
      icon: classes.white,
    },
  };
  return (
    <FormControl fullWidth className={classes.formControl}>
      <InputLabel shrink id="defaultApp" {...InputLabelProps}>
        Default App
      </InputLabel>
      <Select
        {...InputProps}
        labelId="defaultApp"
        id="defaultApp-id"
        value={defaultApp}
        onChange={handleDefaultAppChange}
        displayEmpty
      >
        {apps.map((app) => (
          <MenuItem key={app.url} value={app.url}>
            {app.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MockHook.withHookHoc(
  UserDefaultAppSelectorComponent,
  useUserDefaultAppSelectorLogic
);
